// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

import orderReducer from './slices/orderSlice';
import alertReducer from './slices/alertSlice';
import loadReducer from './slices/loadSlice';
export const store = configureStore({
  reducer: {
    auth: authReducer,
    order: orderReducer,
    alert: alertReducer, 
    load:loadReducer
  },
});
